import {
  useSetting,
  useAssignSetting,
} from "@faire/marketplace-lib/settings/__internal__/useSetting";
import { FE_BRAND_SIDE_CART_REDESIGN_250903 } from "@faire/retailer-settings/FE_BRAND_SIDE_CART_REDESIGN_250903";

export const useSettingBrandSideCartRedesign = (): boolean =>
  useSetting(FE_BRAND_SIDE_CART_REDESIGN_250903);

export const useAssignSettingBrandSideCartRedesign = () =>
  useAssignSetting(FE_BRAND_SIDE_CART_REDESIGN_250903);
